/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReadGeolocalisation } from './ReadGeolocalisation';
import {
    ReadGeolocalisationFromJSON,
    ReadGeolocalisationFromJSONTyped,
    ReadGeolocalisationToJSON,
    ReadGeolocalisationToJSONTyped,
} from './ReadGeolocalisation';

/**
 * 
 * @export
 * @interface ReadAddressDto
 */
export interface ReadAddressDto {
    /**
     * 
     * @type {string}
     * @memberof ReadAddressDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReadAddressDto
     */
    ligne1: string;
    /**
     * 
     * @type {string}
     * @memberof ReadAddressDto
     */
    ligne2?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadAddressDto
     */
    ligne3?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadAddressDto
     */
    codePostal: string;
    /**
     * 
     * @type {string}
     * @memberof ReadAddressDto
     */
    ville: string;
    /**
     * 
     * @type {string}
     * @memberof ReadAddressDto
     */
    pays: string;
    /**
     * 
     * @type {string}
     * @memberof ReadAddressDto
     */
    adresseFormattee?: string;
    /**
     * 
     * @type {ReadGeolocalisation}
     * @memberof ReadAddressDto
     */
    geolocalisation?: ReadGeolocalisation;
}

/**
 * Check if a given object implements the ReadAddressDto interface.
 */
export function instanceOfReadAddressDto(value: object): value is ReadAddressDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('ligne1' in value) || value['ligne1'] === undefined) return false;
    if (!('codePostal' in value) || value['codePostal'] === undefined) return false;
    if (!('ville' in value) || value['ville'] === undefined) return false;
    if (!('pays' in value) || value['pays'] === undefined) return false;
    return true;
}

export function ReadAddressDtoFromJSON(json: any): ReadAddressDto {
    return ReadAddressDtoFromJSONTyped(json, false);
}

export function ReadAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'ligne1': json['ligne1'],
        'ligne2': json['ligne2'] == null ? undefined : json['ligne2'],
        'ligne3': json['ligne3'] == null ? undefined : json['ligne3'],
        'codePostal': json['codePostal'],
        'ville': json['ville'],
        'pays': json['pays'],
        'adresseFormattee': json['adresseFormattee'] == null ? undefined : json['adresseFormattee'],
        'geolocalisation': json['geolocalisation'] == null ? undefined : ReadGeolocalisationFromJSON(json['geolocalisation']),
    };
}

export function ReadAddressDtoToJSON(json: any): ReadAddressDto {
    return ReadAddressDtoToJSONTyped(json, false);
}

export function ReadAddressDtoToJSONTyped(value?: ReadAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'ligne1': value['ligne1'],
        'ligne2': value['ligne2'],
        'ligne3': value['ligne3'],
        'codePostal': value['codePostal'],
        'ville': value['ville'],
        'pays': value['pays'],
        'adresseFormattee': value['adresseFormattee'],
        'geolocalisation': ReadGeolocalisationToJSON(value['geolocalisation']),
    };
}

